import styled from 'styled-components';

export const Wrapper = styled.a`
  align-items: center;
  display: flex;
  flex: 1;
`;

export const Logo = styled.img`
  display: inline-flex;
  margin-right: 12px;
  max-height: 32px;
  max-width: 32px;
  overflow: hidden;
  width: 32px;
`;

export const Name = styled.span`
  display: inline-flex;
  font-size: 14px;
  line-height: 1;
  flex: 1;
  text-align: left;
`;
